<template>
  <list-select
      ref="select"
      async
      :emit-only-value="false"
      v-on:input="(v) => $emit('input', v)"
      :search-data="search"
      v-model="model"
      :parse-callback="parse"
  />
</template>

<script>
import ListSelect from "@/reuse/input/ListSelect"
import {listTitular as list} from "@/domain/validadeDocumentos/services/titular"
export default {
  name: "TitularSelect",
  props: {
    value: {
      required: true
    }
  },
  data () {
    return {
      model: this.value,
      result: []
    }
  },
  watch: {
    value (v) {
      this.$nextTick(() => {
        if (v !== this.model) {
          this.$refs.select.autoSelectValue(v)
        }
      })
    }
  },
  components: {ListSelect},
  methods: {
    search (terms) {
      console.log('Find', this.model)
      const filtros = []
      if (terms) {
        filtros.push('search=' + terms)
      }
      return new Promise((resolve, reject) => {
        list(100, 1, '&' + filtros.join('&'))
            .then(response => {
              this.result = response.data.result
              let list = response.data.result.map((obj) => {
                return {
                  ...obj.pessoa,
                  ...obj,
                  value: obj.id,
                  label: obj.pessoa.name
                }
              }).sort((a, b) => {
                if (a.pessoa.name > b.pessoa.name) {
                  return 1;
                }
                if (a.pessoa.name < b.pessoa.name) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              })
              resolve(list)
            })
            .catch(({response}) => {
              reject(response)
            })
      })
    },
    parse (v) {
      if (v && v.pessoa.name) {
        return v.pessoa.name
      }
      return v
    }
  }
}
</script>
